import { useQuery } from '@apollo/client';
import { Dayjs } from 'dayjs';
import { useMemo } from 'react';
import { GET_DTOOLS_PROJECTS } from 'src/graphql/entities/integrations/dtools/dtools.operations';
import { useNotifications } from 'src/utils/hooks';

export type DtoolsProjectItem = {
  id: string;
  name: string;
  clientName: string;
  modifiedDate: Dayjs;
  createdDate: Dayjs;
  number: string;
  isArchived: boolean;
  // Available fields below should be in sync with GET_DTOOLS_PROJECTS query's return fields.
  // clientId: string;
  // clientNumber: string;
  // systemState: string;
  // stageGroup: string;
  // stage: string;
  // priority: string;
  // price: number;
  // projectManager: string;
  // completedDate: Dayjs;
};

export type GetDtoolsProjectsInput = {
  searchValue?: string;
  pageNumber?: number;
  pageSize?: number;
  includeArchived?: boolean;
};

export type GetDtoolsProjectsParams = {
  params: GetDtoolsProjectsInput;
};

export type GetDtoolsProjectsQuery = {
  getDtoolsProjects: {
    projects?: DtoolsProjectItem[];
    totalProjects: number;
  };
};

export const useGetDtoolsProjects = ({
  searchValue,
  pageSize = 10,
  pageNumber = 1,
  includeArchived = false,
}: GetDtoolsProjectsInput) => {
  const params = useMemo<GetDtoolsProjectsInput>(() => {
    return { searchValue, pageSize, pageNumber, includeArchived };
  }, [searchValue, pageSize, pageNumber, includeArchived]);
  const { showErrorAlert } = useNotifications();
  const { loading, data, error, fetchMore } = useQuery<
    GetDtoolsProjectsQuery,
    GetDtoolsProjectsParams
  >(GET_DTOOLS_PROJECTS, {
    variables: {
      params,
    },
    fetchPolicy: 'network-only',
    // Without this a rejected API key renders as an empty project list rather than a failure.
    onError: (queryError) => {
      showErrorAlert(queryError.message);
    },
  });

  return {
    loading,
    error,
    projects: data?.getDtoolsProjects.projects,
    total: data?.getDtoolsProjects.totalProjects,
    fetchMore,
  };
};
